function Filemanager_choose_image(element) {
  this.$element = $(element);
  this.popup = i4_Popup.get(this.$element);
  this.selectedLabelId = 0;

  this.selectors = {
    // image choose functionality
    imageResult: '.js-filter-result',
    ButtonCancel: '.js-button-cancel',
    ButtonChoose: '.js-button-choose',
    Image: '.js-image',
    ContainerPreview: '.js-container-preview-choose',
    Selected: '.selected',
    filterDecorator: '.js-filter-decorator',

    // label functionality
    ButtonAddLabel: '.f-filemanager-label__add-label',
    TextAddLabel: '.f-filemanager-label__add-label__text',
    InputLabelTextDiv: '.js-add-label-form',
    InputLabelCancel: '.f-filemanager-label__add-label__input__cancel',
    hiddenFieldLabel: '.js-hidden-field-label',
    labelEditBox: '.js-label-edit-box',
    labelEditForm: '.js-label-edit-form',

    // add / edit label
    labelResult: '.js-label-result',
    AddLabelInputField: '#add_label',
    LabelHeading: '.f-filemanager-label__heading-title',
    LabelHeadingEditButton: '.js-edit-label-pen',
    LabelHeadingInputField: '.js-field-label-name',
    LabelHeadingColorInputField: '.js-field-label-color-name',
    LabelHeadingColorPreview: '.js-label-color-preview',
    labelHeadingInputButton: '.js-add-label-button',
    LabelHeadingEditInputButton: '.js-edit-label-button',
    labelDeleteConfirmContainer: '.js-label-delete-confirm',

    DeleteLabel: '.f-filemanager-label__delete',
    DeleteConfirmButton: '.f-filemanager-label__delete-buttons',
    DeleteConfirmButtonNo: '.f-filemanager-label__delete-buttons--no',
    DeleteConfirmButtonYes: '.f-filemanager-label__delete-buttons--yes',
    DeleteLabelRelationButton: '.f-filemanager-choose-image__delete-label-relation',

    // search field clear
    SearchField: '.js-search-field',
    SearchFieldClearButton: ".js-search-clear",

    // preview
    Preview: '.f-filemanager-choose-image__preview',
    PreviewClose: '.f-filemanager-choose-image__preview__close',
    PreviewContainer: '.f-filemanager-choose-image__preview__container',

    // trash images
    // TrashButton: '.f-filemanager-choose-image__delete-label-relation'

  };

  this.classNames = {
    ContainerPreview: 'js-container-preview-choose',
    Selected: 'selected'
  };

  this.data = {
    targetFieldId: 'target-field-id'
  };

  this.triggers = {
    beforeFiltered: 'i4:beforeFiltered',
    afterFiltered: 'i4:afterFiltered',
    updateFilter: 'i4:updateFilter'
  };

  this.init = () => {
    // filter functionality
    this.$filterDecorator = this.$element.find(this.selectors.filterDecorator);
    this.$hiddenFieldLabel = this.$element.find(this.selectors.hiddenFieldLabel);

    // image choose functionality
    this.$imageResult = this.$element.find(this.selectors.imageResult);
    this.$buttonCancel = this.$element.find(this.selectors.ButtonCancel);
    this.$buttonChoose = this.$element.find(this.selectors.ButtonChoose);
    this.$images = this.$element.find(this.selectors.Image);

    this.dataTargetFieldId = this.$element.data(this.data.targetFieldId);
    this.$targetField = $('#' + this.dataTargetFieldId);
    this.$containerPreview = this.$targetField.next(this.selectors.ContainerPreview);

    this.$buttonCancel.on('click', this.$onClickCancel.bind(this));
    this.$buttonChoose.on('click', this.$onClickChoose.bind(this));
    this.$filterDecorator.on(this.triggers.beforeFiltered, this.beforeFiltered.bind(this));
    this.$filterDecorator.on(this.triggers.afterFiltered, this.afterFiltered.bind(this));

    this.$buttonChoose.addClass('invalid');

    if (!this.$containerPreview.length) {
      this.$containerPreview = $('<div></div>').addClass(this.classNames.ContainerPreview);
      this.$targetField.after(this.$containerPreview);
    }

    // label functionality
    this.$labelEditBox = this.$element.find(this.selectors.labelEditBox);
    this.$labelEditForm = this.$element.find(this.selectors.labelEditForm);
    this.$labelResult = this.$element.find(this.selectors.labelResult);
    this.$buttonAddLabel = this.$element.find(this.selectors.ButtonAddLabel);
    this.$textAddLabel = this.$element.find(this.selectors.TextAddLabel);
    this.$inputAddLabelDiv = this.$element.find(this.selectors.InputLabelTextDiv);
    this.$inputLabelCancel = this.$element.find(this.selectors.InputLabelCancel);
    this.$addLabelInputField = this.$element.find(this.selectors.AddLabelInputField);


    this.$labelHeading = this.$element.find(this.selectors.LabelHeading);
    this.$labelHeadingEditButton = this.$element.find(this.selectors.LabelHeadingEditButton);
    this.$labelHeadingInputField = this.$element.find(this.selectors.LabelHeadingInputField);
    this.$labelHeadingColorInputField = this.$element.find(this.selectors.LabelHeadingColorInputField);
    this.$labelHeadingInputButton = this.$element.find(this.selectors.labelHeadingInputButton);
    this.$labelHeadingColorPreview = this.$element.find(this.selectors.LabelHeadingColorPreview);
    this.$labelHeadingEditInputButton = this.$element.find(this.selectors.LabelHeadingEditInputButton);

    this.$labelDeleteConfirmContainer = this.$element.find(this.selectors.labelDeleteConfirmContainer);
    this.$deleteLabel = this.$element.find(this.selectors.DeleteLabel);
    this.$deleteConfirmButtonNo = this.$element.find(this.selectors.DeleteConfirmButtonNo);
    this.$deleteConfirmButtonYes = this.$element.find(this.selectors.DeleteConfirmButtonYes);

    this.$deleteLabelRelationButton = this.$element.find(this.selectors.DeleteLabelRelationButton);

    // search
    this.$searchField = this.$element.find(this.selectors.SearchField);
    this.$searchFieldClearButton = this.$element.find(this.selectors.SearchFieldClearButton);

    // preview
    this.$preview = this.$element.find(this.selectors.Preview);
    this.$previewClose = this.$element.find(this.selectors.PreviewClose);
    this.$previewContainer = this.$element.find(this.selectors.PreviewContainer);

    this.$buttonAddLabel.on('click', this.$onClickAddLabel.bind(this));

    this.$addLabelInputField.on('keyup', this.$onAddLabelInputFieldEnter.bind(this));
    this.$inputLabelCancel.on('click', this.$onInputLabelCancel.bind(this));

    this.$labelHeadingEditButton.on('click', this.$onLabelHeadingEditButton.bind(this));
    this.$labelHeadingInputField.on('keyup', this.$onLabelHeadingInputFieldEnter.bind(this));
    this.$labelHeadingInputButton.on('click', this.$onLabelHeadingInputButton.bind(this));

    this.$labelHeadingEditInputButton.on('click', this.$onLabelHeadingInputSave.bind(this));
    this.$labelHeadingColorInputField.on('keyup', this.$onLabelHeadingColorInputFieldChange.bind(this));


    this.$deleteLabel.on('click', this.$onClickDeleteLabel.bind(this));
    this.$deleteConfirmButtonNo.on('click', this.$onClickDeleteConfirmButtonNo.bind(this));
    this.$deleteConfirmButtonYes.on('click', this.$onClickDeleteConfirmButtonYes.bind(this));

    // search
    this.$searchField.on('keyup', this.$onSearchFieldChange.bind(this));
    this.$searchFieldClearButton.on('click', this.$onClickSearchFieldClearButton.bind(this));

    // preview
    // this.$previewContainer.on('click', this.$onPreviewClose.bind(this));
    this.$previewClose.on('click', this.$onPreviewClose.bind(this));

    // trash
    // this.$trashButton = this.$element.find(this.selectors.TrashButton);
    // this.$trashButton.on('click', this.$onClickTrashButton.bind(this));

    this.initLabels();
  };

  // image choose functionality

  this.$onClickCancel = () => {
    this.$targetField.trigger('i4:choose-cancel');
    this.closePopup();
  };

  this.$onClickChoose = () => {
    if (!this.$buttonChoose.hasClass('invalid')) {
      this.choose();
    }
  };

  this.closePopup = () => {
    var parentPopup = i4_Popup.get(this.dataTargetFieldId);

    if (parentPopup) {
      parentPopup.show();
    }

    this.popup.remove();
  };

  this.choose = () => {
    var selected = this.$element.find(this.selectors.Selected);

    this.$targetField.val(selected.data('filemanager-id'));
    this.$containerPreview.html($('<img></img>').attr('src', selected.find('img').attr('src')));

    this.closePopup();

    this.$targetField.trigger('i4:choose');
    this.$targetField.trigger('i4:choose-complete');
    this.$targetField.parents('fieldset').trigger('i4:change');
  };

  // label functionality

  this.beforeFiltered = () => {
    this.$inputAddLabelDiv.hide();
  };

  this.afterFiltered = () => {

    $('.f-filemanager-choose-image__item').each((function (i, item) {

      // https://api.jqueryui.com/draggable/
      $(item).draggable({
        cursor: 'move',
        revert: 'invalid',
        revertDuration: 300,
        opacity: 0.25,
        snap: '.ui-droppable',
        snapMode: "outer",
        helper: function () {
          return $(this).clone().appendTo('.f-filemanager-choose-image').css('zIndex', 2).show();
        }
      });

      $(item).on('click', (function () {
        $('.f-filemanager-choose-image__item-inner').removeClass(this.classNames.Selected);
        $(item).find('.js-image').addClass(this.classNames.Selected);
        this.$buttonChoose.removeClass('invalid');
      }).bind(this));

      $(item).on('dblclick', (function () {
        this.choose();
      }).bind(this));

      $(item).on('mouseenter', (function () {
        $(item).find('.f-filemanager-choose-image__preview-button').show();
        $(item).find('.f-filemanager-choose-image__trash').show();
      }).bind(this));

      $(item).on('mouseleave', (function () {
        $(item).find('.f-filemanager-choose-image__preview-button').hide();
        $(item).find('.f-filemanager-choose-image__trash').hide();
      }).bind(this));

      $(item).find('.f-filemanager-choose-image__trash').on('click', (function (event) {
        event.preventDefault();
        var filemanagerId = $(event.target).closest('.js-image').attr('data-filemanager-id');
        this.trashImage(filemanagerId);
      }).bind(this));

      $(item).find('.f-filemanager-choose-image__preview-button').on('click', (function (event) {
        event.preventDefault();
        var filemanagerId = $(event.target).closest('.js-image').attr('data-filemanager-id');
        this.showPreview(filemanagerId);
      }).bind(this));

      if (this.selectedLabelId != 0) {
        $(item).on('mouseenter', (function () {
          $(item).find('.f-filemanager-choose-image__delete-label-relation').show();
        }).bind(this));

        $(item).on('mouseleave', (function () {
          $(item).find('.f-filemanager-choose-image__delete-label-relation').hide();
        }).bind(this));

        $(item).find('.f-filemanager-choose-image__delete-label-relation').on('click', (function (event) {
          event.preventDefault();

          var filemanagerId = $(event.target).closest('.js-image').attr('data-filemanager-id');
          this.deleteFilemanagerLabelRelation(filemanagerId, this.selectedLabelId);
        }).bind(this));
      }

    }).bind(this));
  };

  this.$onClickAddLabel = () => {
    this.showAddLabelInput();
  };

  this.$onInputLabelCancel = () => {
    this.hideAddLabelInput();
  };

  this.showAddLabelInput = () => {

    this.$labelHeadingEditButton.removeClass('visible');
    $('.f-filemanager-label__heading-title').hide();

    this.$buttonAddLabel.off('mouseenter');
    this.$buttonAddLabel.off('mouseleave');
    this.$imageResult.fadeOut();
    this.$inputAddLabelDiv.css('display', 'flex');
    this.$addLabelInputField.focus();
  };

  this.hideAddLabelInput = () => {
    this.$inputAddLabelDiv.css('display', 'none');
    this.$addLabelInputField.val('');
    this.$imageResult.fadeIn();

    this.$buttonAddLabel.on('click', this.$onClickAddLabel.bind(this));
  };

  this.$onAddLabelInputFieldEnter = (event) => {
    event.preventDefault();
    if (event.keyCode === 13) {
      this.addLabel();
    }
  };

  this.$onLabelHeadingInputButton = () => {
    if (this.$addLabelInputField.val().trim() != '') {
      this.addLabel();
    } else {
      this.$addLabelInputField.focus();
    }
  };

  this.addLabel = () => {

    var param = jQuery.param({
      js: 'Label',
      call: 'add',
      value: this.$addLabelInputField.val().trim()
    });

    i4_Ajax.factory().
    set_parameter(param).
    set_option({
      on_success: ((response) => {

        if (response == 1) {
          this.initLabels();
          this.hideAddLabelInput();
          this.$imageResult.empty();
        }

      }).bind(this)
    }).
    run();
  };

  this.initLabels = () => {
    var param = jQuery.param({
      js: 'Label',
      call: 'getAll'
    });

    i4_Ajax.factory().
    set_parameter(param).
    set_option({
      on_success: ((response) => {
        this.detachLabelEvents();

        this.$labelResult.empty().append(response);

        this.attachLabelEvents();
        this.makeDroppable();
      }).bind(this)
    }).
    run();
  };

  this.$onLabelHeadingEditButton = () => {
    var display = this.$labelEditBox.css('display');

    switch (display) {
      case 'none':
        this.$labelEditBox.show();
        break;
      default:
        this.$labelEditBox.hide();
        break;
    }
  };

  this.makeDroppable = () => {

    // https://api.jqueryui.com/droppable/
    $(".f-filemanager-label__item--droppable").droppable({
      tolerance: 'pointer',
      drop: (event, ui) => {

        // shrink image if valid drop region
        // if ($(event.target).hasClass('f-filemanager-label__item--droppable')) {
        // 	$(ui.helper).addClass('shrink');
        // }

        var labelId = $(event.target).attr('data-label-id');
        var filemanagerid = $(ui.draggable[0]).find('.js-image').attr('data-filemanager-id');

        var param = jQuery.param({
          js: 'Label',
          call: 'add-label-relation',
          label_id: labelId,
          filemanager_id: filemanagerid,
        });

        i4_Ajax.factory().
        set_parameter(param).
        set_option({
          on_success: ((response) => {
            this.$filterDecorator.trigger(this.triggers.updateFilter);
          }).bind(this)
        }).
        run();

      }
    });
  };

  this.attachLabelEvents = () => {
    const globalThis = this;
    $('.f-filemanager-label__item').each((index, element) => {
      $(element).on('click', function () {
        var labelId = $(this).attr('data-label-id');
        var labelText = $(this).attr('data-label-text');
        var labelColor = $(this).attr('data-label-color');
        if (labelId === 'without') {
          globalThis.selectedLabelId = 'without';
        } else if (labelId > 0) {
          globalThis.selectedLabelId = labelId;
        } else {
          globalThis.selectedLabelId = 0;
        }

        globalThis.$hiddenFieldLabel.val(globalThis.selectedLabelId);
        globalThis.$filterDecorator.trigger(globalThis.triggers.updateFilter);

        $('.f-filemanager-label__heading-title span').val('');
        $('.f-filemanager-label__heading-title span').hide();
        switch (labelId) {
          case '':
            $('.f-filemanager-label__heading-title .all').show();
            break;
          case '0':
            $('.f-filemanager-label__heading-title .all').show();
            break;
          case 'without':
            $('.f-filemanager-label__heading-title .without').show();
            break;
          default:
            $('.f-filemanager-label__heading-title .label').show();
            break;

        }


        globalThis.setLabelHeading(labelId, labelText, labelColor);
        globalThis.$labelEditBox.hide();
        $('.f-filemanager-label__heading-title').show();

      });
    });
  };

  this.setLabelHeading = (labelId, labelText, labelColor) => {

    $('.f-filemanager-label__heading').hide();
    this.$labelHeadingEditButton.removeClass('visible');

    if (labelId != '' && labelId != 0 && labelId != 'without') {
      $('.f-filemanager-label__heading-title .label').text(labelText).css('color', labelColor);
      // $('.f-filemanager-label__heading .label').text(labelText).css('color', labelColor);
      this.$labelHeadingInputField.val(labelText).attr('data-label-id', this.selectedLabelId);
      this.$labelHeadingColorInputField.val(labelColor);
      this.$labelHeadingColorPreview.css({
        'background-color': labelColor
      });
      $('.f-filemanager-label__heading .label').show();
      this.$labelHeadingEditButton.addClass('visible');
    } else {
      if (labelId === 0) {
        $('.f-filemanager-label__heading span.all').show();
      }
      if (labelId === 'without') {
        $('.f-filemanager-label__heading span.without').show();
      }
    }
    $('.f-filemanager-label__heading').fadeIn();
  };

  this.$onLabelHeadingInputFieldEnter = (event) => {
    if (event.keyCode === 13) {
      this.$onLabelHeadingInputSave();
    }
  };

  this.$onLabelHeadingInputSave = () => {
    var param = jQuery.param({
      js: 'Label',
      call: 'edit',
      label_id: this.$labelHeadingInputField.attr('data-label-id'),
      value: this.$labelHeadingInputField.val(),
      color: this.$labelHeadingColorInputField.val()
    });

    i4_Ajax.factory().
    set_parameter(param).
    set_option({
      on_success: ((response) => {
        if (response == 1) {
          this.$labelEditBox.hide();
          $('.f-filemanager-label__heading-title .label').text(this.$labelHeadingInputField.val());
          $('.f-filemanager-label__heading-title .label').css('color', this.$labelHeadingColorInputField.val());
          $('.f-filemanager-label__heading-title .label').show();
          this.initLabels();
          this.$filterDecorator.trigger(this.triggers.updateFilter);
        }

      }).bind(this)
    }).
    run();
  };

  this.$onLabelHeadingColorInputFieldChange = (event) => {
    this.$labelHeadingColorPreview.css({
      'background-color': event.target.value
    });
  };

  this.detachLabelEvents = () => {
    if ($('.f-filemanager-label__item').length > 0) {
      $('.f-filemanager-label__item').each((index, element) => {
        $(element).off('click');
      });
    }
  };

  this.$onClickDeleteLabel = () => {
    this.$labelDeleteConfirmContainer.show();
    this.$labelEditForm.hide();
  };

  this.$onClickDeleteConfirmButtonNo = () => {
    this.$labelDeleteConfirmContainer.hide();
    this.$labelEditForm.show();
  };

  this.$onClickDeleteConfirmButtonYes = () => {
    this.$labelEditBox.hide();

    var param = jQuery.param({
      js: 'Label',
      call: 'delete',
      label_id: this.$labelHeadingInputField.attr('data-label-id')
    });

    i4_Ajax.factory().
    set_parameter(param).
    set_option({
      on_success: ((response) => {
        if (response == 1) {
          this.selectedLabelId = 0;
          this.$hiddenFieldLabel.val(this.selectedLabelId);
          this.initLabels();
          this.$filterDecorator.trigger(this.triggers.updateFilter);
          this.$labelEditForm.show();
          this.$labelDeleteConfirmContainer.hide();
          this.$labelHeadingEditButton.hide();

          $('.f-filemanager-label__heading-title span').hide();
          $('.f-filemanager-label__heading-title .all').show();
        }

      }).bind(this)
    }).
    run();
  };

  this.deleteFilemanagerLabelRelation = (filemanagerId, labelId) => {

    var param = jQuery.param({
      js: 'Label',
      call: 'delete_relation',
      filemanager_id: filemanagerId,
      label_id: labelId
    });

    i4_Ajax.factory().
    set_parameter(param).
    set_option({
      on_success: ((response) => {
        if (response == 1) {
          this.$filterDecorator.trigger(this.triggers.updateFilter);
        }

      }).bind(this)
    }).
    run();
  };

  this.$onSearchFieldChange = (event) => {
    if (event.target.value != '') {
      this.$searchFieldClearButton.show();
    } else {
      this.$searchFieldClearButton.hide();
    }
  };

  this.$onClickSearchFieldClearButton = () => {
    this.$searchField.val('');
    this.$searchFieldClearButton.hide();
  };

  this.showPreview = (filemanagerId) => {
    var param = jQuery.param({
      js: 'Filemanager',
      call: 'get_image',
      filemanager_id: filemanagerId
    });
    i4_Ajax.factory().
    set_parameter(param).
    set_option({
      on_success: ((response) => {
        var data = JSON.parse(response);
        this.$imageResult.hide();
        this.$previewContainer.empty();

        var content = '<img src="' + data.src + '" class="f-filemanager-choose-image__preview__container__image" />';
        content += '<div class="f-filemanager-choose-image__preview__container__fileinfo">' + data.filename + '<br>' + data.width + '&nbsp;x&nbsp;' + data.height + '&nbsp;px<br>' + data.size + '<br>';
        content += '<a href="' + data.src + '" download="' + data.filename + '" class="i4-button i4-button--primary f-filemanager-choose-image__preview__container__download-button">Download</a></div>';

        this.$previewContainer.html(content);
        $('body').css({
          'overflow': 'hidden'
        });
        this.$preview.fadeIn();
      }).bind(this)
    }).
    run();
  };

  this.$onPreviewClose = () => {
    this.$preview.fadeOut();
    this.$imageResult.show();
    $('body').css({
      'overflow': 'auto'
    });
  };

  this.trashImage = (filemanagerId) => {

    /**
     *	test if polyfill is working
     *	https://caniuse.com/#feat=mdn-javascript_builtins_number_isinteger
     *	https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
     */
    // const isInteger = Number.isInteger(99999999999999999999999);
    // console.log('isInteger', isInteger);

    const really = window.confirm('Really delete?');

    if (really) {
      var param = jQuery.param({
        js: 'Filemanager',
        call: 'filemanager_remove',
        filemanager_id: filemanagerId
      });
      i4_Ajax.factory().
      set_parameter(param).
      set_option({
        on_success: (() => {
          this.$filterDecorator.trigger(this.triggers.updateFilter);
        }).bind(this)
      }).
      run();
    }
  };
}
